var _style, _g, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatarRRelease(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56.4 49.1",
    style: {
      enableBackground: "new 0 0 56.4 49.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.4,3.8c-4.4,0-8,3.6-8,8c0,4.4,3.6,8,8,8c4.4,0,8-3.6,8-8C54.4,7.3,50.8,3.8,46.4,3.8z M46.4,18.5 c-3.7,0-6.7-3-6.7-6.7c0-3.7,3-6.7,6.7-6.7c3.7,0,6.7,3,6.7,6.7C53.1,15.4,50.1,18.5,46.4,18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.8,10.5c0-1.4-1.1-2.5-2.4-2.5h-3.7v7.4h1.2v-2.5H47l1,2.5h1.2l-1-2.6C49.1,12.5,49.8,11.6,49.8,10.5z  M47.3,11.7h-2.5V9.3h2.5c0.7,0,1.2,0.5,1.2,1.2C48.6,11.2,48.1,11.7,47.3,11.7z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.6,42.6L38.6,42.6c-1.4,0-3-0.5-4.6-1.5c-1.6-1-3-2.1-4.1-3.2c-1.1-1.1-2.4-2.6-4.1-4.5 c-1.6-1.9-2.8-3.2-3.4-3.8h0.8c3.9,0,7.3-1.2,10.1-3.7c2.8-2.4,4.2-5.7,4.2-9.6c0-4.5-1.5-7.9-4.4-10.2c-2.9-2.3-6.5-3.4-10.8-3.4 H3.8v43.7h4.3V29.6h8.7c0.9,0.6,2.2,1.9,4,3.9c1.7,2,3.3,3.9,4.9,5.7c1.5,1.8,3.4,3.5,5.7,5c2.2,1.4,4.4,2.2,6.5,2.2l0,0h3.1v-3.8 H38.6z M8.1,26V6.6h14.6c3,0,5.4,0.8,7.4,2.5c2,1.7,2.9,4.1,2.9,7.3c0,3-1,5.3-3,7c-2,1.7-4.4,2.6-7.3,2.6H8.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarRRelease);
export default __webpack_public_path__ + "static/media/Avatar-R-Release.59ceac56.svg";
export { ForwardRef as ReactComponent };